import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../../common/constants";
import { deleteFirmwareBlobUrl } from "../../../config";
import api from "../../../api";

const DELETE_FIRMWARE: string = "deleteFirmware";

interface IDeleteFirmwareState {
  status: string;
  msg: string | null;
  error: string | null;
}

const initialState: IDeleteFirmwareState = {
  status: Status.IDLE,
  msg: null,
  error: null,
};

export const deleteFirmware: any = createAsyncThunk(
    DELETE_FIRMWARE,
  async ({ name, version }: { name, version }) => {
    try {
      const url = `${deleteFirmwareBlobUrl}?name=${name}&version=${version}`;
      const response = await api.delete(url);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "Delete firmware failed";
    }
  }
);

const deleteFirmwareSlice = createSlice({
  name: "deleteFirmware",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteFirmware.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
        state.error = null;
      })
      .addCase(deleteFirmware.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.msg = action.payload?.message || "Firmware deleted successfully";
      })
      .addCase(deleteFirmware.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
        state.msg = action.error.message || "Failed to delete firmware";
      });
  },
});

type Selector = {
  deleteFirmwareApi: ReturnType<typeof deleteFirmwareSlice.reducer>;
};

export const selector = (store: Selector) => store["deleteFirmwareApi"];

export default deleteFirmwareSlice.reducer;
